import lodashGet from 'lodash/get';
import lodashSet from 'lodash/set';

export const filterUniqueElementsInArrayOfObjects = (array: Array<any>) => {
  let pushedIds: string[] = [];
  let uniqueArray: any[] = [];

  array.forEach(element => {
    if (!pushedIds.includes(element['@id'])) {
      uniqueArray.push(element);
      pushedIds.push(element['@id']);
    }
  });

  return uniqueArray;
};

export const copyArrayOfObjectWithoutReference = (arrayToCopy: any[]): any[] => {
  return arrayToCopy.map((objectToCopy: {}) => {
    return { ...objectToCopy };
  });
};

export const fixRoundedTotal = (
  sortedArray: any[],
  expectedTotal: number | undefined,
  path: string,
  precision: number = 3,
) => {
  if (!expectedTotal || sortedArray.length === 0) {
    return;
  }

  const actualTotal = sortedArray.reduce((total, arrayItem) => total + Number(lodashGet(arrayItem, path)), 0);

  if (actualTotal === 0) {
    return;
  }

  let maxIndex = 0;
  let maxValue = Number(lodashGet(sortedArray[0], path));
  sortedArray.forEach((v, index) => {
    const currentValue = Number(lodashGet(v, path));
    if (currentValue > maxValue) {
      maxValue = currentValue;
      maxIndex = index;
    }
  });

  if (maxValue === 0) {
    return;
  }

  const delta = expectedTotal - actualTotal;
  lodashSet(sortedArray[maxIndex], path, (maxValue + delta).toFixed(precision));
};
